import axios from 'axios';
import { toast } from 'react-hot-toast';
import { getAuthHeaders } from './authHeader';

const BASE_URL = process.env.NEXT_PUBLIC_SERVER_URL;

const sendNetworkReq = async ({
	method,
	url,
	body,
	headers,
	auth,
	loadingMessage,
	successMessage,
	onSuccess,
}) => {
	let toastId;
	const canToast = typeof window !== 'undefined';

	if (!BASE_URL) {
		console.error('Server URL (BASE_URL) is not defined!');
		if (canToast)
			toast.error('Server URL (BASE_URL) is not defined!', { id: toastId });
		return { error: true, errorData: 'BASE_URL is not defined' };
	}

	const finalUrl = url?.startsWith('https://')
		? url
		: `${BASE_URL}${url || ''}`;

	if (!auth) {
		try {
			if (loadingMessage && canToast)
				toastId = toast.loading(loadingMessage);
			// Only the Firebase user's token is sent here; admin (auth: true)
			// requests below keep using the admin token untouched.
			// Never send the token to a different host (absolute URLs).
			const authHeaders = finalUrl.startsWith(BASE_URL)
				? await getAuthHeaders()
				: {};
			const response = await axios({
				method: method,
				headers: { ...authHeaders, ...headers },
				url: finalUrl,
				data: body,
			});
			if (successMessage && canToast)
				toast.success(successMessage ? successMessage : 'Successful!', {
					id: toastId,
				});
			if (onSuccess) onSuccess(response.data);
			return response.data;
		} catch (error) {
			console.error(error);
			if (canToast)
				toast.error(
					error?.response?.data?.msg
						? error?.response?.data?.msg
						: 'Something went wrong!',
					{
						id: toastId,
					}
				);
			return { error: true, errorData: error };
		}
	} else {
		const accessToken = localStorage.getItem('accessToken');
		if (accessToken) {
			try {
				if (loadingMessage && canToast)
					toastId = toast.loading(loadingMessage);
				const response = await axios({
					method: method,
					headers: {
						Authorization: `Bearer ${accessToken}`,
						...headers,
					},
					url: finalUrl,
					data: body,
				});
				if (successMessage && canToast)
					toast.success(successMessage ? successMessage : 'Successful!', {
						id: toastId,
					});
				if (onSuccess) onSuccess(response.data);
				return response.data;
			} catch (error) {
				console.error(error);
				if (error?.response?.status == 401 || error?.response?.status == 403) {
					localStorage.clear();
					window.location.reload();
					if (canToast) toast.error('Session expired!');
					return;
				}
				if (canToast)
					toast.error(
						error?.response?.data?.msg
							? error?.response?.data?.msg
							: 'Something went wrong!',
						{
							id: toastId,
						}
					);
				return { error: true, errorData: error };
			}
		}
	}
};

export default sendNetworkReq;
